import type { RuleNames } from "./feature-names";

/** German names of the company rules and rule categories. Same keys as rules.fr.ts. */
export const rulesDe: RuleNames = {
  rules: {
    REFUND_OWNER_APPROVAL_ABOVE_RULE: "Freigabe durch den Inhaber ab",
    ID_IMAGE_RETENTION_RULE: "Aufbewahrung der Ausweisbilder",
    FIRST_REPLY_TARGET_RULE: "Frist für die erste Antwort",
    INTERIM_SUSPENSION_REVIEW_RULE: "Prüfung einer vorläufigen Sperre",
    UNANSWERED_JOB_EXPIRY_RULE: "Ablauf einer unbeantworteten Anfrage",
    SUBSCRIPTION_GRACE_PERIOD_RULE: "Kulanzfrist eines Abos",
    STAFF_SESSION_INACTIVITY_RULE: "Abmeldung nach Inaktivität",
  },
  categories: {
    payments: "Zahlungen",
    support: "Fälle",
    safety: "Vertrauen & Sicherheit",
    onboarding: "Prüfung",
    jobs: "Anfragen",
    access: "Zugriff",
  },
};
